<template>
    <b-container fluid style="margin-top: 60px">
        <h1>
            {{ $t('nav_mixProductie', { ns: 'nav' }) }}
        </h1>
        <b-row>
            <b-col sm="10">
                <period-selector
                    v-model="selectDays"
                    v-bind:periodDays="periodeDagen"
                    @change="setNewDates"
                />
            </b-col>
            <b-col sm="2">
                <b-col sm="11">
                    <b-button @click="loadData()" class="bgc_aux_normal"
                        ><font-awesome-icon
                            icon="arrow-down"
                            size="1x"
                        />&nbsp;{{ $t('com_show', { ns: 'common' }) }}
                    </b-button>
                </b-col>
                <b-col sm="1"> </b-col>
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12">
                <div v-if="showFilter">
                    <b-row no-gutters>
                        <b-col lg="6" class="my-1">
                            <b-form-group
                                :label="$t('com_filter', { ns: 'common' })"
                                label-for="filter-input"
                                label-cols-sm="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-input-group size="sm">
                                    <b-form-input
                                        v-model="filter"
                                        type="search"
                                        :placeholder="
                                            $t('com_typetosearch', {
                                                ns: 'common'
                                            })
                                        "
                                    ></b-form-input>

                                    <b-input-group-append>
                                        <b-button
                                            :disabled="!filter"
                                            @click="filter = ''"
                                            >{{
                                                $t('com_wis', { ns: 'common' })
                                            }}</b-button
                                        >
                                    </b-input-group-append>
                                </b-input-group>

                                <b-input-group size="sm">
                                    <b-button
                                        v-if="checkRight('StockIn')"
                                        size="sm"
                                        @click="createNewItem"
                                        class="mr-1"
                                        ><font-awesome-icon
                                            icon="folder-plus"
                                            size="1x"
                                        />
                                        {{ strNieuw }}
                                    </b-button>
                                    &nbsp;
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col lg="6" class="my-1">
                            <b-form-group
                                :label="$t('com_perpagina', { ns: 'common' })"
                                label-for="per-page-select"
                                label-cols-sm="6"
                                label-cols-md="4"
                                label-cols-lg="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    align="fill"
                                    size="sm"
                                    class="my-0"
                                ></b-pagination>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-input-group>
                        <b-button
                            v-if="checkRight('StockIn')"
                            size="sm"
                            @click="createNewItem"
                            class="mr-1"
                            ><font-awesome-icon icon="folder-plus" size="1x" />
                            {{ strNieuw }}
                        </b-button>
                    </b-input-group>
                </div>
                <b-table
                    :items="displayList"
                    :fields="visibleFields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    stacked="md"
                    show-empty
                    :empty-text="$t('com_geen_data', { ns: 'common' })"
                    small
                    striped
                    @filtered="onFiltered"
                    @row-clicked="editItem"
                >
                    <template v-slot:cell(actions)="row">
                        <div class="form-inline">
                            <b-button
                                size="sm"
                                @click="editItem(row.item)"
                                class="bgc_aux_warning"
                                ><font-awesome-icon icon="edit" size="1x" />
                            </b-button>
                            <b-button
                                v-if="checkRight('StockIn')"
                                size="sm"
                                @click="createNewItem(row.item)"
                                class="bgc_aux_normal"
                                :disabled="!edit(row.item)"
                                ><font-awesome-icon
                                    icon="folder-plus"
                                    size="1x"
                                />
                            </b-button>
                            <b-button
                                v-if="checkRight('StockDelete')"
                                size="sm"
                                @click="verwijderItem(row.item)"
                                class="bgc_aux_alarm"
                                ><font-awesome-icon
                                    icon="trash-alt"
                                    size="1x"
                                />
                            </b-button>
                        </div>
                    </template>

                    <template v-slot:cell(actueelRecept)="row">
                        <b-badge
                            v-if="row.item.actueelRecept < 1"
                            variant="info"
                        >
                            {{ $t('com_gesloten', { ns: 'common', val: '' }) }}
                        </b-badge>
                    </template>
                </b-table>
                <div v-if="displayList.length == 0">
                    {{ strNoData }}
                </div>
            </b-col>
        </b-row>
        <ingredient-production-modal
            v-if="detailsVisible"
            :inItem="currentItem"
            v-model="detailsVisible"
            :allowEdit="allowEdit"
            @hide="reset"
        />
    </b-container>
</template>

<script>
import PeriodSelector from '../components/PeriodSelector.vue';
import DateHelper from '../../models/DateHelper';
import Helper from '../../models/Helper';
import { loadItem, loadList } from '../../models/DataHelper';
import { Permission } from '../../models/Permissions';
import { Feature } from '../../models/Features';
import { IngredientProduction } from '../../models/Recept';
import IngredientProductionModal from './IngredientProductionModal.vue';

export default {
    name: 'IngredientProductionBase',
    data() {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 40, { value: 100, text: '100' }],
            filter: null,
            filterOn: [],
            van: null,
            tot: null,
            dag: 'day',
            isDagInfo: true,
            currentItem: null,
            detailsVisible: false,
            selectDays: null,
            periodeDagen: 184,
            editDagen: -10,
            forceRefresh: false,
            refresh: 0,
            prodinfoLijst: [],
            bakkenlijst: [],
            displayFilterCount: 10,
            onbekend: this.$t('prod_onbekend', {
                ns: 'production'
            }),
            allowEdit: false
        };
    },
    components: {
        PeriodSelector,
        IngredientProductionModal
    },
    computed: {
        strNieuw() {
            return this.$t('com_newx', {
                ns: 'common',
                val: this.$t('prod_stockitem', {
                    ns: 'production'
                })
            });
        },
        strNoData() {
            return Helper.stringformat(
                this.$t('prod_nomaintenancedata', {
                    ns: 'production'
                }),
                this.van,
                this.tot
            );
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'productiedatum',
                    label: this.$t('com_datum', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        const temp = DateHelper.convertedToDate(
                            item.productiedatum
                        );
                        return temp;
                    }
                },
                {
                    key: 'batchID',
                    label: '#',
                    sortable: false,
                    visible: true
                },
                {
                    key: 'naam',
                    label: this.$t('com_product', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'hoeveelheid',
                    label: this.$t('com_number', { ns: 'common' }),
                    sortable: false,
                    visible: true
                },
                {
                    key: 'eenheidNaam',
                    label: this.$t('com_unit', { ns: 'common' }),
                    sortable: false,
                    visible: true
                },
                {
                    key: 'tht',
                    label: this.$t('com_tht', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        const temp = DateHelper.convertedToDate(item.tht);
                        return temp;
                    }
                },
                {
                    key: 'actueelRecept',
                    label: this.$t('com_status', { ns: 'common' }),
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        displayList() {
            return this.prodinfoLijst;
        },
        showFilter() {
            return this.displayList
                ? this.displayList.length > this.displayFilterCount
                : false;
        }
    },
    methods: {
        reset() {
            this.detailsVisible = false;
        },
        edit(row) {
            const o = DateHelper.determineVanTot(new Date(), this.editDagen);
            const magNog = o.van < row.productiedatum;
            const hasright = this.checkRight('BatchUpdate');
            return hasright && magNog && row.actueelRecept;
        },
        async getDetailItem(item) {
            return await loadItem(
                'preparation/loadIngredientProduction',
                { ingredientProductionID: item.id },
                this.$t
            );
        },
        async editItem(row) {
            const refreshedItem = await this.getDetailItem(row);
            this.allowEdit = this.edit(row);
            this.currentItem = refreshedItem;
            this.detailsVisible = true;
        },
        async createNewItem(item) {
            let base = {};
            if (!(item instanceof PointerEvent) && item !== null) {
                base = await this.getDetailItem(item);
            }
            this.allowEdit = true;
            this.currentItem = new IngredientProduction(base, true);
            this.currentItem.voorraadID = null;
            this.currentItem.batchID = null;
            this.currentItem.productiedatum = null;
            this.currentItem.starttijd = null;
            this.currentItem.eindtijd = null;
            this.currentItem.id = -1;
            this.detailsVisible = true;
        },
        async verwijderItem(item) {
            const refreshedItem = await this.getDetailItem(item);
            if (item.status == window.constants.STOCKUNUSED) {
                const doClose = await this.$root.showConfirmationBox(
                    this.$t('com_delete', {
                        ns: 'common',
                        val: this.$t('prod_stockitem', { ns: 'production' })
                    }) +
                        ' : ' +
                        item.batchID
                );
                if (doClose) {
                    const selectionData = {
                        id: refreshedItem.id,
                        LastUpdated: refreshedItem.gewijzigd
                    };
                    await loadItem(
                        'preparation/deleteProduction',
                        selectionData,
                        this.$t
                    );
                }
                this.loadData();
            } else {
                this.$root.showMessageBox(
                    this.$t('prod_nodelete', {
                        ns: 'production'
                    })
                );
            }
        },
        setNewDates(selDates) {
            const refreshData =
                this.van != selDates.van ||
                this.tot != selDates.tot ||
                this.dag != selDates.dag;
            this.van = selDates.van;
            this.tot = selDates.tot;
            this.dag = selDates.dag;
            this.isDagInfo = selDates.dag == 'day';
            if (refreshData) this.loadData();
        },
        async loadData() {
            const selectionData = {
                from: DateHelper.localDateToUTC(this.van),
                until: DateHelper.localDateToUTC(this.tot)
            };
            this.prodinfoLijst = await loadList(
                'preparation/getIngredientProductionInfo',
                'preparation/loadIngredientProductionInfo',
                selectionData,
                true,
                this.$t
            );
            this.totalRows = this.prodinfoLijst ? this.prodinfoLijst.length : 0;
            this.aangeraakt_teller += 1;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        },
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        }
    },
    mounted: function () {
        this.loadData();
        this.totalRows = this.displayList ? this.displayList.length : 0;
    },
    async created() {
        const lijst = await loadList(
            'masterdata/getConstantsLijst',
            'masterdata/loadApplicationConstants',
            null,
            this.forceRefresh,
            this.$t
        );
        const con = lijst
            ? lijst.find((x) => x.text == window.constants.APPCONST_EDITDAYS)
            : null;
        this.editDagen = con ? con.value : 30;
    }
};
</script>

<style scoped></style>
